export default "__VITE_ASSET__B35oAyNU__"